import React from "react";
import { TextType, Wrapper } from "./index.style";
import { Avatar, CloseIcon, Flex } from "@fluentui/react-northstar";
import { TextUsername } from "../index.style";

const HeaderContent = ({ closePopup, content = "", icon = "", user }) => {
    return (
        <Wrapper fill space="between" vAlign="center">
            <Flex gap="gap.small" vAlign=" center">
                <Flex gap="gap.smaller" vAlign="center">
                    <Avatar name={user.name} image={user.avatar} size="small" />
                    <TextUsername content={user.name} />
                </Flex>
            </Flex>
            <Flex>
                <CloseIcon
                    style={{ color: "black", cursor: "pointer" }}
                    onClick={(e, i) => {
                        e.stopPropagation();
                        e.preventDefault();
                        closePopup();
                    }}
                />
            </Flex>
        </Wrapper>
    );
};

export default HeaderContent;
